import { useEffect, useMemo } from "react";
import { Loading } from "../../../components/Loading";
import Tabs, { SubTab } from "../../../components/Tabs";
import { useGetAdminReportsQuery } from "./adminReportsApiSlice";
import AdminLevelReports from "./AdminLevelReports";
import AdminCourseLevelReports from "./AdminCourseLevelReports";
import { useAdminReportsFilters } from "./useAdminReportsFilters";

export enum AdminReportsSubTabs {
	Admin = "Admin",
	Course = "Course-Level",
}

export default function AdminReports() {
	const adminReportsInfoResult = useGetAdminReportsQuery();
	const canViewAdminReports = adminReportsInfoResult.data;
	const { activeSubTab, setActiveSubTab } = useAdminReportsFilters();

	const initialSubTabs: SubTab[] = useMemo(
		() => [
			{
				name: AdminReportsSubTabs.Admin,
				current: canViewAdminReports === true,
				content: <AdminLevelReports canViewAdminReports={canViewAdminReports ?? false} />,
			},
			{
				name: AdminReportsSubTabs.Course,
				current: canViewAdminReports === false,
				content: <AdminCourseLevelReports />,
			},
		],
		[canViewAdminReports]
	);

	useEffect(() => {
		// Only set the active subtab if it hasn't been set yet (null) and canViewAdminReports has finished being called
		if (activeSubTab === null && canViewAdminReports != undefined) {
			if (canViewAdminReports === false) {
				setActiveSubTab(AdminReportsSubTabs.Course);
			} else {
				setActiveSubTab(AdminReportsSubTabs.Admin);
			}
		}
	}, [canViewAdminReports, activeSubTab, setActiveSubTab]);

	const handleSubTabChange = (tabName: string) => {
		setActiveSubTab(tabName);
	};

	return (
		<section>
			<h1>Reports</h1>
			<Loading loading={adminReportsInfoResult.isLoading} />
			{!adminReportsInfoResult.isLoading && (
				<Tabs
					initialSubTabs={initialSubTabs}
					ariaLabel="Admin Report Tabs"
					containerClass="mt-4"
					forceActiveTabName={activeSubTab ?? undefined}
					onTabChange={handleSubTabChange}
				/>
			)}
		</section>
	);
}
